import './style.less'
export const IconInformation = (props) => {
    return (
        <div className='container'>
            <p className='title'>{props?.title}</p>
            <div className='desc_icon_container'>
               <div className='icon'> {props?.icon}</div>
                <p className='description'>{props?.description ?? "-"}</p>
            </div>
        </div>
    )
}